<!-- NOT COMPLETED-->
<div
  class="tentativi bg-white col-10 offset-1"
  *ngIf="!interaction?.completed.onComplete && interaction?.tentativiMax"
  [class.alerts-border]="alertColor === 'red'"
  [class.success-border]="alertColor === 'green'">
  <span class="number">{{interaction?.tentativiRimanenti}}</span>
  <span *ngIf="localStorage.getItem('l') === 'it'">Tentativi rimanenti</span>
  <span *ngIf="localStorage.getItem('l') === 'en'">Remaining attempts</span>
  <span *ngIf="localStorage.getItem('l') === 'fr'">Tentatives restantes</span>
</div>

<app-puzzle *ngIf="interaction.content.gameType === 'puzzle'" [interactionId]="interaction.id"></app-puzzle>
<app-trova-errore *ngIf="interaction.content.gameType === 'trova-errore'" [interactionId]="interaction.id"
                  (tentativiStatus)="flash($event)"></app-trova-errore>
<app-memory *ngIf="interaction.content.gameType === 'memory'" [interactionId]="interaction.id"></app-memory>
<app-new-scratch *ngIf="interaction.content.gameType === 'scratch'" [interactionId]="interaction.id"></app-new-scratch>
<app-crucintarsio *ngIf="interaction.content.gameType === 'crucintarsio'"
                  [interactionId]="interaction.id"></app-crucintarsio>
<app-quadratomagico *ngIf="interaction.content.gameType === 'quadratomagico'"
                    [interactionId]="interaction.id"></app-quadratomagico>
<app-quiz *ngIf="interaction.content.gameType === 'quiz'" [interactionId]="interaction.id"></app-quiz>
<app-mappa *ngIf="interaction.content.gameType === 'mappa'" [interactionId]="interaction.id"></app-mappa>
